import { render } from "./AgentEnv.vue?vue&type=template&id=56a010f3"
import script from "./AgentEnv.vue?vue&type=script&lang=js"
export * from "./AgentEnv.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__